import React, { useState} from 'react'
import fire from './fire'
const Login =(props) =>{
    const {
        email,
      setEmail,
      passowrd,
      setPassword,
      handleLogin ,
      handleSignUp ,
      hasAccount , 
      setHasAccount,
      emailError,
      passwordError
    } = props
    const [show, setShow] = useState(false)
    const [emailRe, setEmailRe] = useState('')
    const [emailErrorRe, setEmailErrorRe] = useState('');
    const [showMsg, setShowMsg] = useState(false)
    const changeHandler = () =>{
      setShow(!show)
    }
    const clearErrorsRe =() =>{
      setEmailErrorRe('')
      
    }

    const resetHandler = async() =>{
      clearErrorsRe()
      var status = true
      await fire.auth().sendPasswordResetEmail(emailRe)
      .catch(err =>{
        status = false
        switch(err.code){

          case "auth/invalid-email":
          case "auth/user-disabled":
          case "auth/user-not-found":
            setEmailErrorRe(err.message);
            break;
          default:
            setEmailErrorRe("Somthing went wrong");
            break;

        }
      })
      if(status){
        
        setShowMsg(true)
      }else{
        setShowMsg(false)
      }
      
      
    }

     return (
        <section className = "" >
        
        <header className="mb-4 shadow">
        <nav className="navbar navbar-dark bg-dark primary-styled-border">
          <div className="container">
            
              <h1 style={{ fontSize: '2.25rem' }}>
                <span className="text-primary1">&lt;/&gt; </span>
                <span style={{ color: 'white' }}>Code</span><span className="text-primary1">Zap</span>
              </h1>    
            
            <div>
              
            </div>
          </div>
        </nav>
      </header>


         <section className = "login">

         <div className="container">
      <div className="row align-items-center">
        
        <div className="col-lg-12">
          <div className="container">
            <div className="row">
            <div className = "loginContainer" style = {{display: show ? "none" : "flex"}}>
            
              <h1 style={{ fontSize: '2.25rem' ,width: "20%",alignSelf: "center",marginBottom: "10%", marginTop:"-1%"}}>
                <span className="text-primary1">&lt;/&gt;</span>
              </h1>    
            
            
              
            <label>Username</label>
            <input 
                type = "text" 
                autoFocus 
                required 
                value = {email} 
                onChange = {(e) => setEmail(e.target.value)}
            /> 
            <p style = {{color:"white"}} className = "errorMag">{emailError}</p>
            <label>Password</label>
            <input 
                type = "password"
                required
                value = {passowrd}
                onChange = {(e) => setPassword(e.target.value)}
            />
            <p  className = "errorMag" style = {{color:"white"}}>{passwordError}</p>
            
            <p style = {{color:"white",cursor:"pointer"}} onClick = {changeHandler}>Forgot your password?</p>
            
            <div className = "btnContainer">
                {hasAccount ? (
                    <>
                    <button style = {{ backgroundColor:"#ff405f"}}  onClick = {handleLogin}>Sign In</button>
                    <p>Don't have an account ? <span onClick = {() => setHasAccount(!hasAccount)}>Sign Up</span></p>
                    </>
                ) : (
                    <>
                    <button style = {{ backgroundColor:"#ff405f"}} onClick = {handleSignUp}>Sign Up</button>
                    <p>Have an account <span onClick = {() => setHasAccount(!hasAccount)}>Sign In</span></p>
                    </>
                )}
            </div>
        </div>

        <div className = "loginContainer" style = {{display: show ? "block" : "none"}}>
            
            <i className="fa fa-arrow-left" aria-hidden="true" style = {{color:"white", fontSize:"35px", cursor:"pointer"}} onClick = {changeHandler}></i>
            <label style = {{marginTop:"22%"}}>Enter Email</label>
            <input 
                type = "text" 
                autoFocus 
                required 
                value = {emailRe} 
                onChange = {(e) => setEmailRe(e.target.value)}
            /> 
            <p style = {{color:"white"}} className = "errorMag">{emailErrorRe}</p>
            {showMsg ? <p style = {{color:"white"}} className = "errorMag">Please check your mail !</p>: <p></p>}
            <div className = "btnContainer">
                
              <button style = {{ backgroundColor:"#ff405f"}} onClick = {resetHandler} >Submit</button>
                    
                    
                
            </div>
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          
         </section>
    </section>
     )
}

export default Login